<div class="no-resources-container mx-auto w-100">
  <img
    class="mx-auto d-flex"
    src="../../../../assets/images/topics/nodocs-img.svg"
    alt=""
  />
  <p class="text-center pt-3">{{ 'pages.TOPICS.NO-RESOURCES' | transloco }}</p>
</div>
